var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovedStatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5599 10.74L20.1999 9.16C19.9399 8.86 19.7299 8.3 19.7299 7.9V6.2C19.7299 5.14 18.8599 4.27 17.7999 4.27H16.0999C15.7099 4.27 15.1399 4.06 14.8399 3.8L13.2599 2.44C12.5699 1.85 11.4399 1.85 10.7399 2.44L9.16988 3.81C8.86988 4.06 8.29988 4.27 7.90988 4.27H6.17988C5.11988 4.27 4.24988 5.14 4.24988 6.2V7.91C4.24988 8.3 4.03988 8.86 3.78988 9.16L2.43988 10.75C1.85988 11.44 1.85988 12.56 2.43988 13.25L3.78988 14.84C4.03988 15.14 4.24988 15.7 4.24988 16.09V17.8C4.24988 18.86 5.11988 19.73 6.17988 19.73H7.90988C8.29988 19.73 8.86988 19.94 9.16988 20.2L10.7499 21.56C11.4399 22.15 12.5699 22.15 13.2699 21.56L14.8499 20.2C15.1499 19.94 15.7099 19.73 16.1099 19.73H17.8099C18.8699 19.73 19.7399 18.86 19.7399 17.8V16.1C19.7399 15.71 19.9499 15.14 20.2099 14.84L21.5699 13.26C22.1499 12.57 22.1499 11.43 21.5599 10.74ZM16.1599 10.11L11.3299 14.94C11.1899 15.08 10.9999 15.16 10.7999 15.16C10.5999 15.16 10.4099 15.08 10.2699 14.94L7.84988 12.52C7.55988 12.23 7.55988 11.75 7.84988 11.46C8.13988 11.17 8.61988 11.17 8.90988 11.46L10.7999 13.35L15.0999 9.05C15.3899 8.76 15.8699 8.76 16.1599 9.05C16.4499 9.34 16.4499 9.82 16.1599 10.11Z",
    fill: "#00B533"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedStatusIcon);
export default __webpack_public_path__ + "static/media/approved-status-icon.6fb833c7b0ffb8e6b72215c6c4cc9803.svg";
export { ForwardRef as ReactComponent };